import { InjectionToken } from '@angular/core'
import { EnvAuthConfig } from './env.auth.config'

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT')

export interface Environment {
  production: boolean
  appScheme: string
  apiBasePath?: string
  chatBasePath?: string
  chatWssPath?: string
  configId: string
  oauthConfig: EnvAuthConfig
  firebase: any
}
